exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.shadow[data-v-b03d65e8] {\n    background: transparent;\n}\n}\n", ""]);

